//　下载表格
export const exportExcel = (data, fileName = '导出表格.xlsx') => {
  let blobObj = new Blob([data], { type: 'application/vnd.ms-excel' })
  // for IE
  if (window.navigator && window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blobObj, fileName)
  } else {
    let blobUrl = URL.createObjectURL(blobObj)
    const link = document.createElement('a') // 创建a标签
    link.href = blobUrl
    link.download = fileName
    link.click() // 模拟点击a标签
    URL.revokeObjectURL(link.href)
  }
}

export const downloadExcel = (res, title) =>　{
  const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
  const a = document.getElementById('a_id')
  a.href = URL.createObjectURL(blob)
  a.download = title + '.xls'
  a.click()
}
